import {
  helpAndSupportIcon,
  logoutIcon,
  userImg,
  NewChatIcon,
  AiCharacterIcon,
  StackIcon,
  ClaimAirdropIcon,
  Logo,
  temeLogo,
} from "images";
import { TbRating18Plus } from "react-icons/tb";
import { FaCoins } from "react-icons/fa";

import classes from "./Sidebar.module.css";
import { Link, NavLink, useNavigate, useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { Button, Heading, Input, Text } from "components/common";

import clsx from "clsx";
import { MdClose } from "react-icons/md";
import Devider2 from "components/common/Devider2/Devider";
import useOnClickOutside, { useScreenSize, useWrapperHeight } from "hooks";
import Dropdown from "pages/ManageAccount/Dropdown/Dropdown";

import SingleCharacter from "./SingleCharacter";
import { useLiveQuery } from "dexie-react-hooks";
import { db } from "db";
import { useAppContext } from "ContextProvider/ContextProvider";
import ManageAccountLayout from "Layout/ManageAccountLayout/ManageAccountLayout";
import Cookies from "js-cookie";

const navItems = [
  {
    icon: () => null,
    navItem: "New Chat",
    to: "/chat",
  },
  // {
  //   icon: () => null,
  //   navItem: "AI Characters",
  //   to: "/ai-characters",
  // },
];

const Sidebar = ({
  sidebar,
  setSidebar,
  aiCharacters,
  data,
  isLoggedIn,
  setIsLoggedIn,
  userData,
  setUserData,
}) => {
  const { myTheme } = useAppContext();
  const [showManageAccountModal, setShowManageAccountModal] = useState(false);
  const [searchValue, setSearchValue] = useState("");

  console.log(aiCharacters, "aiCharacters");
  const ref = useRef();
  const charactersRef = useRef();

  const navigate = useNavigate();

  const [regularChats, setRegularChats] = useState([]);

  const dbMessages = useLiveQuery(() =>
    db.chatMetadata
      .orderBy("lastUpdated")
      .reverse()
      .toArray()
      .then((metadata) =>
        metadata.map((m) => ({
          id: m.chatId,
          character: m.character,
          icon: m.character
            ? aiCharacters?.find(
                (a) => a.id.toLowerCase() == m.character.toLowerCase()
              )?.icon
            : "",
          chat: m.heading,
          lastUpdated: m.lastUpdated,
        }))
      )
  );

  console.log(dbMessages, "dbMessages");

  useEffect(() => {
    if (dbMessages) {
      setRegularChats(dbMessages);
    }
  }, [dbMessages, aiCharacters]);

  const { chatId } = useParams();

  useEffect(() => {
    if (chatId) {
      setActiveChat(chatId);
    }
  }, [chatId]);

  // Filter chats based on search value
  const filteredChats = searchValue
    ? regularChats?.filter((chat) =>
        chat?.chat?.toLowerCase().includes(searchValue?.toLowerCase())
      )
    : regularChats;

  const [activeChat, setActiveChat] = useState(null);
  const inputRef = useRef();

  const userWrapperRef = useRef(null);
  const userWrapperHeight = useWrapperHeight(userWrapperRef);

  const isSmallScreen = useScreenSize(1280);

  useEffect(() => {
    if (isSmallScreen) {
      setSidebar(false);
    }
  }, [isSmallScreen]);
  useOnClickOutside(ref, () => {
    if (isSmallScreen) setSidebar(false);
  });

  const handleUpgradeClick = (e) => {
    e.stopPropagation(); // Prevent the parent div's onClick from firing
    if (!userData) {
      navigate("/login");
      return;
    }
    setShowManageAccountModal(true);
  };

  return (
    <>
      <section
        ref={ref}
        style={{ "--spaceInBottom": `${userWrapperHeight}px` }}
        className={clsx(
          classes.sidebar,
          sidebar ? classes.showSidebar : classes.hideSidebar
        )}
      >
        <div className={classes.container}>
          <div className={classes.navItemsContainer}>
            <div className={classes.header}>
              <Link to="/">
                <span className={classes.logo}>
                  {/* <Logo color={myTheme.color} /> */}
                  <img src={temeLogo} alt="#" className={classes.logo} />
                </span>
              </Link>
              <button
                className={classes.sidebarButton}
                onClick={() => setSidebar((prev) => !prev)}
              >
                <MdClose />
              </button>
            </div>

            <Input
              ref={inputRef}
              ctrlP
              className={classes.searchContainer}
              search
              value={searchValue}
              setValue={setSearchValue}
              placeholder="Search"
            />

            <div className={classes.navItems}>
              {navItems?.map((el, i) => (
                <NavLink
                  to={el.to}
                  key={i}
                  className={({ isActive }) =>
                    isActive
                      ? [classes.navItem, classes.navActive].join(" ")
                      : classes.navItem
                  }
                  onClick={() => {
                    if (isSmallScreen) {
                      setSidebar((prev) => !prev);
                    }
                  }}
                >
                  {({ isActive, isPending }) => (
                    <>
                      <span className={classes.navIcon}>
                        {el.icon({
                          color: isActive ? myTheme.color : "#A8ABAC",
                        })}
                      </span>
                      <span>{el.navItem}</span>
                    </>
                  )}
                </NavLink>
              ))}
            </div>
          </div>

          <div className={classes.chatsAndCharacters}>
            <div className={classes.aiCharacters} ref={charactersRef}>
              <Text
                primitive400
                xs
                className={clsx(classes.label, classes.chatsLabel)}
              >
                Chats
              </Text>

              <div className={classes.characters}>
                {filteredChats?.map((el) => (
                  <SingleCharacter
                    {...el}
                    key={el.id}
                    parentRef={charactersRef}
                    isActive={activeChat === el.id}
                    identifier={el.id}
                    chat={el.chat}
                    onClick={() => {
                      if (el.character) {
                        navigate(`/chat/${el.id}/${el.character}`);
                      } else {
                        navigate(`/chat/${el.id}`);
                      }
                      setActiveChat(el.id);
                    }}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className={classes.userWrapper} ref={userWrapperRef}>
          <div
            onClick={() => userData && setShowManageAccountModal(true)}
            className={classes.userContainer}
          >
            {/* <img src={userImg} alt="#" className={classes.userImg} /> */}
            <div>
              <Heading sm primitive100 medium>
                {/* {userData?.username
                  ? userData?.username[0].toUpperCase() +
                    userData?.username.slice(1)
                  : "Guest"} */}
              </Heading>
              <Button
                sm
                primary
                className={classes.freePlanButton}
                onClick={handleUpgradeClick}
              >
                <img src={temeLogo} alt="Algora" className={classes.premiumIcon} />
                {userData?.is_pro ? "Manage Subscription" : "Upgrade to PRO"}
              </Button>
            </div>
          </div>
          <Devider2 />
          <div>
            {/* <button
              className={clsx(classes.navItem, classes.helpAndSupportButton)}
            >
              <img
                src={helpAndSupportIcon}
                alt="#"
                className={classes.navIcon}
              />
              <p>Help & Support</p>
            </button> */}
            {isLoggedIn && (
              <button
                onClick={() => {
                  Cookies.remove("token");
                  setIsLoggedIn(false);
                  setUserData(null);
                  navigate("/login");
                }}
                className={clsx(classes.navItem, classes.logoutButton)}
              >
                <img src={logoutIcon} alt="#" className={classes.navIcon} />
                <p>Logout</p>
              </button>
            )}
          </div>
        </div>
      </section>
      {userData && (
        <ManageAccountLayout
          isActive={showManageAccountModal}
          onClose={() => setShowManageAccountModal(false)}
          isLoggedIn={true}
          userData={userData}
        />
      )}
    </>
  );
};

export default Sidebar;
